module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-23.d046a12b.png";